import { useState } from 'react';
import { ProgramFileUploadField } from './ProgramFileUpload/ProgramFileUpload';

export function ProgramFileForm({ isDelete }) {
    return <ProgramFileUploadField />;
}
